import { render, staticRenderFns } from "./elementComponent.vue?vue&type=template&id=240792d8&scoped=true&"
import script from "./elementComponent.vue?vue&type=script&lang=js&"
export * from "./elementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240792d8",
  null
  
)

export default component.exports